/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchNotificationHistoryResponse } from './search-notification-history-response';


export interface SearchNotificationHistoryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchNotificationHistoryResponse> | null;
}

